const init = {
  isLogin: false,
  token: localStorage.getItem("token") || null,
  user: {}
};

const user = (state = init, action) => {
  switch (action.type) {
    case "SET_USER":
      action.user.isLogin = true;
      if (action.user.token) {
        localStorage.setItem("token", action.user.token);
      } else {
        action.user.token = localStorage.getItem("token");
      }
      return action.user;
    case "LOGOUT_USER":
      localStorage.removeItem("token");
      window.location.replace("/");
      return init;
    default:
      return state;
  }
};

export default user;
